import Logger, { LoggerOrigin } from '../Logger';
import { ApiError } from './ApiError';
import { getCommonAuthenticatedHeaders } from './HeaderUtils';

export async function execGet<T>(
  apiEndpoint: string,
  accessToken: string,
): Promise<T> {
  const response = await fetch(getFullUrl(apiEndpoint), {
    method: 'GET',
    headers: getCommonAuthenticatedHeaders(accessToken),
  });

  return handleFetchResponse(response);
}

export async function execPost<T>(
  apiEndpoint: string,
  body: object,
  accessToken: string,
): Promise<T> {
  const response = await fetch(getFullUrl(apiEndpoint), {
    method: 'POST',
    headers: getCommonAuthenticatedHeaders(accessToken),
    body: JSON.stringify(body),
  });

  return handleFetchResponse(response);
}

export function getFullUrl(apiEndpoint: string) {
  const base = (import.meta.env.VITE_PAYMENT_API ?? '').replace(/\/$/, '');
  return `${base}/${apiEndpoint}`;
}

async function handleFetchResponse(response: Response) {
  if (response.status === 204 && response.ok) {
    return;
  }

  const textResponse = await response.text();
  let jsonResponse;

  try {
    jsonResponse = await JSON.parse(textResponse);
  } catch {
    Logger.warn(
      LoggerOrigin.RequestUtils,
      'Failed to parse JSON response. Was it as JSON? Will use it as string',
    );
  }

  if (response.ok) {
    return jsonResponse ?? textResponse;
  }

  if (Array.isArray(jsonResponse)) {
    const errMsg = jsonResponse
      .reduce((msg, err) => `${msg}\n${err?.detail}\n`, '')
      .slice(1);

    throw new ApiError(response.status, response.statusText, errMsg);
  }

  throw new ApiError(response.status, response.statusText, '');
}
